import React, { Fragment } from "react";
import { useNavigate } from 'react-router-dom';

// Material UI
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import VisibilityIcon from "@mui/icons-material/Visibility";

// Components
import { DataGrid } from '@arredo/reactjs-ui';

import WrapperDatePicker from '../../../../components/wrapperDatapicker';
import Dropdown from '../../../../components/inputs/dropdown';

// Hooks
import useCashRegisters from '../../../../hooks/cashRegisters/useCashRegisters';
import usePaymentMethodSummary from '../../../../hooks/cashRegisters/usePaymentMethodSummary';

// Models
import { columns } from '../../../../models/PaymentMethods';

const SellerSales = () => {
    const { paymentMethodSummary, loading, filters, setFilters } = usePaymentMethodSummary();
    const { cashRegisters, loading: loadingCashRegisters } = useCashRegisters({ isImprest: false });
    const push = useNavigate();

    const handleFilterChange = (event) => {
        const value = event.target.value !== '-1'
            ? event.target.value
            : '';

        setFilters({ ...filters, [event.target.name]: value });
    }

    const handleClickView = (item) => {
        let queryString = `from=${filters.from}&to=${filters.to}&cashType=${item.cashType}`;

        if (filters.cashRegisterId)
            queryString += `&cashRegisterId=${filters.cashRegisterId}`;
        push(`/cashRegisters/movements?${queryString}`)
    }

    return (
        <Grid container spacing={3}>
            <Grid
                size={{
                    xs: 12,
                    md: "grow"
                }}
            >
                <Typography variant='h4'>
                    Medios de pago
                </Typography>
            </Grid>
            <Grid
                size={{
                    xs: 12,
                    md: 2
                }}
            >
                <Dropdown
                    fullWidth
                    name='cashRegisterId'
                    onChange={handleFilterChange}
                    size='small'
                    label='Caja'
                    getOptionLabel={(option) => option?.name}
                    getOptionValue={(option) => option?.id}
                    value={filters?.cashRegisterId || '-1'}
                    values={[{ name: 'Todos', id: '-1' }].concat(cashRegisters)}
                    disabled={loadingCashRegisters}
                />
            </Grid>
            <Grid
                size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                }}
            >

                <WrapperDatePicker
                    filters={filters?.from}
                    handleFilterChange={handleFilterChange}
                    type="from"
                />
            </Grid>
            <Grid
                size={{
                    xs: 6,
                    md: 3,
                    lg: 2
                }}
            >

                <WrapperDatePicker
                    filters={filters?.to}
                    handleFilterChange={handleFilterChange}
                    type="to"
                />
            </Grid>
            <Grid size={12}>
                <DataGrid
                    columns={columns}
                    rows={paymentMethodSummary}
                    loading={loading}
                    actions={({ row }) => (
                        <>
                            {
                                row.cashType &&
                                <IconButton onClick={() => handleClickView(row)} size="large">
                                    <VisibilityIcon />
                                </IconButton>
                            }
                        </>
                    )}
                />
            </Grid>
        </Grid>
    );
}

export default SellerSales;